// extracted by mini-css-extract-plugin
export default {"aboutBlockImage":"styles_aboutBlockImage__O35wn"};